// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 전체 컨테이너 */
.scenario-container {
  display: flex;
  height: 100vh;
  background-color: white;
}

/* 왼쪽 사이드바 */
.scenario-sidebar {
  width: 280px;
  border-right: 1px solid #e2e8f0;
  background-color: #f8fafc;
  padding: 20px;
}

.scenario-sidebar h2 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 20px;
  color: #1e293b;
}

.scenario-list {
  overflow-y: auto;
  max-height: calc(100vh - 100px);
}

.scenario-item {
  padding: 15px;
  margin-bottom: 10px;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.scenario-item:hover {
  border-color: #94a3b8;
  background-color: #f8fafc;
}

.scenario-item.active {
  border-color: #0ea5e9;
  background-color: #f0f9ff;
}

.scenario-name {
  font-weight: 500;
  color: #1e293b;
  margin-bottom: 4px;
}

.scenario-name-en {
  font-size: 13px;
  color: #64748b;
}

/* 메인 컨텐츠 영역 */
.content-area {
  flex: 1 1;
  padding: 30px;
  overflow-y: auto;
}

.content-header {
  margin-bottom: 30px;
}

.content-header h1 {
  font-size: 24px;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 8px;
}

.content-header p {
  color: #64748b;
}

/* 탭 네비게이션 */
.tab-navigation {
  display: flex;
  border-bottom: 1px solid #e2e8f0;
  margin-bottom: 24px;
  gap: 20px;
}

.tab-button {
  padding: 12px 20px;
  font-size: 15px;
  font-weight: 500;
  color: #64748b;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  cursor: pointer;
  transition: all 0.2s ease;
}

.tab-button:hover {
  color: #0ea5e9;
}

.tab-button.active {
  color: #0ea5e9;
  border-bottom-color: #0ea5e9;
}

/* 편집 가능한 필드 */
.editable-field {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  margin-bottom: 20px;
  padding: 20px;
}

.field-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.field-header h3 {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
}

/* 수정/저장 버튼 */
.edit-button {
  padding: 10px 22px;
  color: white;
  background-color: #0ea5e9;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  transition: background-color 0.2s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  white-space: nowrap;
  line-height: 1;
  max-height: 32px;
  width: 75px;

}

.edit-button:hover {
  background-color: #0284c7;
}

.edit-button .icon {
  width: 16px;
  height: 16px;
}

/* 텍스트 에디터 */
.field-content textarea {
  width: 100%;
  min-height: 200px;
  padding: 15px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 14px;
  line-height: 1.6;
  resize: vertical;
}

.content-display {
  background-color: #f8fafc;
  padding: 15px;
  border-radius: 6px;
  min-height: 200px;
  font-size: 14px;
  line-height: 1.6;
  white-space: pre-wrap;
}

/* 소스 목록 */
.sources-list {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 20px;
}

.source-item {
  padding: 12px;
  margin-bottom: 10px;
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.source-item:hover {
  border-color: #0ea5e9;
  background-color: #f0f9ff;
}

.source-title {
  color: #0ea5e9;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  display: block;
  margin-bottom: 6px;
}

.source-score {
  font-size: 12px;
  color: #64748b;
  background-color: #e2e8f0;
  padding: 4px 8px;
  border-radius: 12px;
}

/* 에러 메시지 */
.error-message {
  color: #ef4444;
  background-color: #fef2f2;
  padding: 12px;
  border-radius: 6px;
  margin: 10px 0;
}

/* 선택되지 않은 상태 메시지 */
.no-selection {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #64748b;
  font-size: 16px;
}

/* 사이드바 헤더 */
.sidebar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

/* 생성 버튼 */
.create-button {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  font-size: 14px;
  background-color: #0ea5e9;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.create-button:hover {
  background-color: #0284c7;
}

/* 삭제 버튼 */
.delete-button {
  padding: 6px;
  color: #ef4444;
  background: none;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.delete-button:hover {
  background-color: #fee2e2;
}

/* 시나리오 아이템 레이아웃 */
.scenario-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.scenario-info {
  flex: 1 1;
}

/* 생성 폼 */
.create-form {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 24px;
}

.create-form h2 {
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 24px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  font-weight: 500;
  color: #1e293b;
  margin-bottom: 8px;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 14px;
}

.form-actions {
  display: flex;
  gap: 12px;
  margin-top: 24px;
}

.submit-button {
  padding: 10px 20px;
  background-color: #0ea5e9;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.submit-button:disabled {
  background-color: #94a3b8;
  cursor: not-allowed;
}

.cancel-button {
  padding: 10px 20px;
  background-color: #e2e8f0;
  color: #64748b;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.cancel-button:hover {
  background-color: #cbd5e1;
}

/* 로딩 상태 */
.loading {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  color: #64748b;
}

.eg-text-fields {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
}

.eg-text-fields .form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.eg-text-fields label {
  font-weight: 600;
  color: #333;
}

.eg-text-fields input,
.eg-text-fields textarea {
  padding: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
}

.eg-text-fields textarea {
  min-height: 100px;
  resize: vertical;
}

.eg-text-display {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.eg-text-display h4 {
  margin: 0;
  color: #2c3e50;
  font-size: 1.2rem;
}

.eg-text-display h5 {
  margin: 0;
  color: #34495e;
  font-size: 1.1rem;
}

.eg-text-display p {
  margin: 0;
  color: #666;
  line-height: 1.5;
}

.common-prompt-fields {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  width: 100%;
}

.common-prompt-fields .form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.common-prompt-fields label {
  font-weight: 600;
  color: #333;
  font-size: 1rem;
}

.common-prompt-fields textarea {
  padding: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
  min-height: 120px;
  resize: vertical;
}

.common-prompt-display {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.prompt-section {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.prompt-section h4 {
  margin: 0;
  color: #2c3e50;
  font-size: 1.1rem;
  font-weight: 600;
}

.prompt-section p {
  margin: 0;
  color: #666;
  line-height: 1.6;
  white-space: pre-wrap;
}

.image-shape-selector {
  display: flex;
  gap: 1rem;
  margin-top: 0.5rem;
}

.shape-button {
  padding: 0.5rem 1rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: grey;
  cursor: pointer;
  transition: all 0.2s;
}

.shape-button.active {
  background: #007bff;
  color: white;
  border-color: #0056b3;
}

.shape-button:hover {
  background: #f0f0f0;
}

.shape-button.active:hover {
  background: #0056b3;
}

.generated-image {
  width: 100%;
  height: auto;
  object-fit: cover;
  transition: border-radius 0.3s ease;
}

.generated-image.circle {
  border-radius: 150px;
}

.generated-image.square {
  border-radius: 0;
}`, "",{"version":3,"sources":["webpack://./src/css/scenario_management.css"],"names":[],"mappings":"AAAA,YAAY;AACZ;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;AACzB;;AAEA,YAAY;AACZ;EACE,YAAY;EACZ,+BAA+B;EAC/B,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA,cAAc;AACd;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sCAAsC;EACtC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,WAAW;;AAEb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,UAAU;AACV;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,UAAU;AACV;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA,SAAS;AACT;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,UAAU;AACV;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["/* 전체 컨테이너 */\n.scenario-container {\n  display: flex;\n  height: 100vh;\n  background-color: white;\n}\n\n/* 왼쪽 사이드바 */\n.scenario-sidebar {\n  width: 280px;\n  border-right: 1px solid #e2e8f0;\n  background-color: #f8fafc;\n  padding: 20px;\n}\n\n.scenario-sidebar h2 {\n  font-size: 20px;\n  font-weight: 600;\n  margin-bottom: 20px;\n  color: #1e293b;\n}\n\n.scenario-list {\n  overflow-y: auto;\n  max-height: calc(100vh - 100px);\n}\n\n.scenario-item {\n  padding: 15px;\n  margin-bottom: 10px;\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.scenario-item:hover {\n  border-color: #94a3b8;\n  background-color: #f8fafc;\n}\n\n.scenario-item.active {\n  border-color: #0ea5e9;\n  background-color: #f0f9ff;\n}\n\n.scenario-name {\n  font-weight: 500;\n  color: #1e293b;\n  margin-bottom: 4px;\n}\n\n.scenario-name-en {\n  font-size: 13px;\n  color: #64748b;\n}\n\n/* 메인 컨텐츠 영역 */\n.content-area {\n  flex: 1;\n  padding: 30px;\n  overflow-y: auto;\n}\n\n.content-header {\n  margin-bottom: 30px;\n}\n\n.content-header h1 {\n  font-size: 24px;\n  font-weight: 600;\n  color: #1e293b;\n  margin-bottom: 8px;\n}\n\n.content-header p {\n  color: #64748b;\n}\n\n/* 탭 네비게이션 */\n.tab-navigation {\n  display: flex;\n  border-bottom: 1px solid #e2e8f0;\n  margin-bottom: 24px;\n  gap: 20px;\n}\n\n.tab-button {\n  padding: 12px 20px;\n  font-size: 15px;\n  font-weight: 500;\n  color: #64748b;\n  background: none;\n  border: none;\n  border-bottom: 2px solid transparent;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.tab-button:hover {\n  color: #0ea5e9;\n}\n\n.tab-button.active {\n  color: #0ea5e9;\n  border-bottom-color: #0ea5e9;\n}\n\n/* 편집 가능한 필드 */\n.editable-field {\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  padding: 20px;\n}\n\n.field-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 15px;\n}\n\n.field-header h3 {\n  font-size: 16px;\n  font-weight: 600;\n  color: #1e293b;\n  margin: 0;\n}\n\n/* 수정/저장 버튼 */\n.edit-button {\n  padding: 10px 22px;\n  color: white;\n  background-color: #0ea5e9;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 13px;\n  transition: background-color 0.2s ease;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  white-space: nowrap;\n  line-height: 1;\n  max-height: 32px;\n  width: 75px;\n\n}\n\n.edit-button:hover {\n  background-color: #0284c7;\n}\n\n.edit-button .icon {\n  width: 16px;\n  height: 16px;\n}\n\n/* 텍스트 에디터 */\n.field-content textarea {\n  width: 100%;\n  min-height: 200px;\n  padding: 15px;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  font-size: 14px;\n  line-height: 1.6;\n  resize: vertical;\n}\n\n.content-display {\n  background-color: #f8fafc;\n  padding: 15px;\n  border-radius: 6px;\n  min-height: 200px;\n  font-size: 14px;\n  line-height: 1.6;\n  white-space: pre-wrap;\n}\n\n/* 소스 목록 */\n.sources-list {\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 20px;\n}\n\n.source-item {\n  padding: 12px;\n  margin-bottom: 10px;\n  background-color: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n}\n\n.source-item:hover {\n  border-color: #0ea5e9;\n  background-color: #f0f9ff;\n}\n\n.source-title {\n  color: #0ea5e9;\n  font-size: 14px;\n  font-weight: 500;\n  text-decoration: none;\n  display: block;\n  margin-bottom: 6px;\n}\n\n.source-score {\n  font-size: 12px;\n  color: #64748b;\n  background-color: #e2e8f0;\n  padding: 4px 8px;\n  border-radius: 12px;\n}\n\n/* 에러 메시지 */\n.error-message {\n  color: #ef4444;\n  background-color: #fef2f2;\n  padding: 12px;\n  border-radius: 6px;\n  margin: 10px 0;\n}\n\n/* 선택되지 않은 상태 메시지 */\n.no-selection {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  color: #64748b;\n  font-size: 16px;\n}\n\n/* 사이드바 헤더 */\n.sidebar-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n/* 생성 버튼 */\n.create-button {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 16px;\n  font-size: 14px;\n  background-color: #0ea5e9;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.create-button:hover {\n  background-color: #0284c7;\n}\n\n/* 삭제 버튼 */\n.delete-button {\n  padding: 6px;\n  color: #ef4444;\n  background: none;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.delete-button:hover {\n  background-color: #fee2e2;\n}\n\n/* 시나리오 아이템 레이아웃 */\n.scenario-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.scenario-info {\n  flex: 1;\n}\n\n/* 생성 폼 */\n.create-form {\n  background: white;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 24px;\n}\n\n.create-form h2 {\n  font-size: 20px;\n  font-weight: 600;\n  color: #1e293b;\n  margin-bottom: 24px;\n}\n\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  display: block;\n  font-weight: 500;\n  color: #1e293b;\n  margin-bottom: 8px;\n}\n\n.form-group input,\n.form-group textarea {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  font-size: 14px;\n}\n\n.form-actions {\n  display: flex;\n  gap: 12px;\n  margin-top: 24px;\n}\n\n.submit-button {\n  padding: 10px 20px;\n  background-color: #0ea5e9;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.submit-button:disabled {\n  background-color: #94a3b8;\n  cursor: not-allowed;\n}\n\n.cancel-button {\n  padding: 10px 20px;\n  background-color: #e2e8f0;\n  color: #64748b;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.cancel-button:hover {\n  background-color: #cbd5e1;\n}\n\n/* 로딩 상태 */\n.loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  color: #64748b;\n}\n\n.eg-text-fields {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  width: 100%;\n}\n\n.eg-text-fields .form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.eg-text-fields label {\n  font-weight: 600;\n  color: #333;\n}\n\n.eg-text-fields input,\n.eg-text-fields textarea {\n  padding: 0.75rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 1rem;\n}\n\n.eg-text-fields textarea {\n  min-height: 100px;\n  resize: vertical;\n}\n\n.eg-text-display {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.eg-text-display h4 {\n  margin: 0;\n  color: #2c3e50;\n  font-size: 1.2rem;\n}\n\n.eg-text-display h5 {\n  margin: 0;\n  color: #34495e;\n  font-size: 1.1rem;\n}\n\n.eg-text-display p {\n  margin: 0;\n  color: #666;\n  line-height: 1.5;\n}\n\n.common-prompt-fields {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  width: 100%;\n}\n\n.common-prompt-fields .form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.common-prompt-fields label {\n  font-weight: 600;\n  color: #333;\n  font-size: 1rem;\n}\n\n.common-prompt-fields textarea {\n  padding: 0.75rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 1rem;\n  min-height: 120px;\n  resize: vertical;\n}\n\n.common-prompt-display {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.prompt-section {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.prompt-section h4 {\n  margin: 0;\n  color: #2c3e50;\n  font-size: 1.1rem;\n  font-weight: 600;\n}\n\n.prompt-section p {\n  margin: 0;\n  color: #666;\n  line-height: 1.6;\n  white-space: pre-wrap;\n}\n\n.image-shape-selector {\n  display: flex;\n  gap: 1rem;\n  margin-top: 0.5rem;\n}\n\n.shape-button {\n  padding: 0.5rem 1rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  background: grey;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.shape-button.active {\n  background: #007bff;\n  color: white;\n  border-color: #0056b3;\n}\n\n.shape-button:hover {\n  background: #f0f0f0;\n}\n\n.shape-button.active:hover {\n  background: #0056b3;\n}\n\n.generated-image {\n  width: 100%;\n  height: auto;\n  object-fit: cover;\n  transition: border-radius 0.3s ease;\n}\n\n.generated-image.circle {\n  border-radius: 150px;\n}\n\n.generated-image.square {\n  border-radius: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
